<template>
    <header id="header" class="header d-flex align-items-center fixed-top">
        <div class="container position-relative d-flex align-items-center justify-content-between">

        <a href="index.html" class="logo d-flex align-items-center me-auto me-xl-0">
            <!-- Uncomment the line below if you also wish to use an image logo -->
            <!-- <img src="assets/img/logo.webp" alt=""> -->
            <h1 class="sitename">Dewiya-Tech</h1><span>.</span>
        </a>

        <nav id="navmenu" class="navmenu">
            <ul>
            <li><a href="#hero" class="active">Accueil</a></li>
            <li><a href="#about">À propos</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#portfolio">Portfolio</a></li>
            <!-- <li><a href="#pricing">Pricing</a></li> -->
            <li><a href="#team">Équipe</a></li>
            <li class="dropdown"><a href="#"><span>Produits</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                <li><a href="https://liza.dewiyatech.com" target="_blank">Liza</a></li>
                <!-- <li class="dropdown"><a href="#"><span>Deep Dropdown</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
                    <ul>
                    <li><a href="#">Deep Dropdown 1</a></li>
                    <li><a href="#">Deep Dropdown 2</a></li>
                    <li><a href="#">Deep Dropdown 3</a></li>
                    <li><a href="#">Deep Dropdown 4</a></li>
                    <li><a href="#">Deep Dropdown 5</a></li>
                    </ul>
                </li> -->
                <li><a href="#">Shappu</a></li>
                <li><a href="#">Huremas</a></li>
                <li><a href="#">WekaPesa</a></li>
                <li><a href="#">Kurahisisha</a></li>
                </ul>
            </li>
            <li><a href="#contact">Contact</a></li>
            </ul>
            <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <a class="btn-getstarted" href="#about">Commencez maintenant</a>

        </div>
    </header>

    <main class="main">

        <!-- Hero Section -->
        <section id="hero" class="hero section">

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row align-items-center mb-5">
            <div class="col-lg-6 mb-4 mb-lg-0">
                <div class="badge-wrapper mb-3">
                <div class="d-inline-flex align-items-center rounded-pill border border-accent-light">
                    <div class="icon-circle me-2">
                    <i class="bi bi-bell"></i>
                    </div>
                    <span class="badge-text me-3">Solutions innovantes</span>
                </div>
                </div>

                <h1 class="hero-title mb-4">Accélérer la croissance de votre entreprise grâce à une technologie innovante</h1>

                <p class="hero-description mb-4">Nous fournissons les outils dont vous avez besoin pour réussir. Parlez-nous de votre projet. Obtenez une consultation gratuite.</p>

                <div class="cta-wrapper">
                <a href="#" class="btn btn-primary">En savoir plus</a>
                </div>
            </div>

            <div class="col-lg-6">
                <div class="hero-image">
                <img src="frontend/assets/img/illustration/illustration-16.webp" alt="Business Growth" class="img-fluid" loading="lazy">
                </div>
            </div>
            </div>

            <div class="row feature-boxes">
            <div class="col-lg-4 mb-4 mb-lg-0" data-aos="fade-up" data-aos-delay="200">
                <div class="feature-box">
                <div class="feature-icon me-sm-4 mb-3 mb-sm-0">
                    <i class="bi bi-gear"></i>
                </div>
                <div class="feature-content">
                    <h3 class="feature-title">Déploiement rapide</h3>
                    <p class="feature-text">Rapidité, fiabilité, automatisation et réduction des risques, permettant à nos équipes de fournir de la valeur plus efficacement et plus fréquemment.</p>
                </div>
                </div>
            </div>

            <div class="col-lg-4 mb-4 mb-lg-0" data-aos="fade-up" data-aos-delay="300">
                <div class="feature-box">
                <div class="feature-icon me-sm-4 mb-3 mb-sm-0">
                    <i class="bi bi-window"></i>
                </div>
                <div class="feature-content">
                    <h3 class="feature-title">Sécurité avancée</h3>
                    <p class="feature-text">Nous développons une approche proactive, multicouche et intelligente qui s’adapte en permanence aux menaces émergentes, en utilisant des technologies de pointe et une compréhension approfondie du comportement des attaquants pour protéger les actifs numériques critiques.</p>
                </div>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="400">
                <div class="feature-box">
                <div class="feature-icon me-sm-4 mb-3 mb-sm-0">
                    <i class="bi bi-headset"></i>
                </div>
                <div class="feature-content">
                    <h3 class="feature-title">Assistance dédiée</h3>
                    <p class="feature-text">Nous garantissons que le logiciel reste efficace, sécurisé et adapté aux besoins des clients sur le long terme, transformant un investissement technologique en un avantage durable.</p>
                </div>
                </div>
            </div>
            </div>

        </div>

        </section><!-- /Hero Section -->

        <!-- About Section -->
        <section id="about" class="about section">

        <div class="container">

            <div class="row gy-4">

            <div class="col-lg-6 content" data-aos="fade-up" data-aos-delay="100">
                <p class="who-we-are">Qui nous sommes</p>
                <h3>Libérer le potentiel grâce à une stratégie créative</h3>
                <p class="fst-italic">
                    Chez Dewiya Technology, nous ne créons pas seulement des technologies, nous bâtissons des partenariats durables. Confiez-nous vos projets, et découvrez comment l'innovation, la sécurité et un support sans faille peuvent propulser votre entreprise vers de nouveaux sommets.
                </p>
                <ul>
                <li><i class="bi bi-check-circle"></i> <span>Travailler ensemble est primordial pour notre succès. Nous encourageons la diversité d'opinion et la confiance.</span></li>
                <li><i class="bi bi-check-circle"></i> <span>Traiter tous les employés, fournisseurs et partenaires avec respect. Nous prospérons sur la transparence et l'honnêteté.</span></li>
                <li><i class="bi bi-check-circle"></i> <span>Nous sommes passionnés par le succès de nos employés, de nos partenaires et de nos produits.</span></li>
                </ul>
                <a href="#" class="read-more"><span>En savoir plus</span><i class="bi bi-arrow-right"></i></a>
            </div>

            <div class="col-lg-6 about-images" data-aos="fade-up" data-aos-delay="200">
                <div class="row gy-4">
                <div class="col-lg-6">
                    <img src="frontend/assets/img/about/about-portrait-1.jpg" class="img-fluid" alt="">
                </div>
                <div class="col-lg-6">
                    <div class="row gy-4">
                    <div class="col-lg-12">
                        <img src="frontend/assets/img/about/about-8.jpg" class="img-fluid" alt="">
                    </div>
                    <div class="col-lg-12">
                        <img src="frontend/assets/img/about/about-12.jpg" class="img-fluid" alt="">
                    </div>
                    </div>
                </div>
                </div>

            </div>

            </div>

        </div>
        </section><!-- /About Section -->

        <!-- How We Work Section -->
        <section id="how-we-work" class="how-we-work section">

        <!-- Section Title -->
        <div class="container section-title" data-aos="fade-up">
            <h2>Comment nous travaillons</h2>
            <p>Chez Dewiya-Tech, le développement d'un logiciel est un processus collaboratif et rigoureux, conçu pour garantir que la solution finale réponde parfaitement à vos besoins, tout en étant performante, sécurisée et évolutive. Voici les étapes clés de notre méthodologie :</p>
        </div><!-- End Section Title -->

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="steps-5">
            <div class="process-container">

                <div class="process-item" data-aos="fade-up" data-aos-delay="200">
                <div class="content">
                    <span class="step-number">01</span>
                    <div class="card-body">
                    <div class="step-icon">
                        <i class="bi bi-pencil-square"></i>
                    </div>
                    <div class="step-content">
                        <h3>Planification du projet</h3>
                        <p>L'étape cruciale qui transforme une idée en une feuille de route concrète et gérable. C'est le processus par lequel nous définissons "quoi", "qui", "quand" et "comment" un logiciel sera développé.</p>
                    </div>
                    </div>
                </div>
                </div><!-- End Process Item -->

                <div class="process-item" data-aos="fade-up" data-aos-delay="300">
                <div class="content">
                    <span class="step-number">02</span>
                    <div class="card-body">
                    <div class="step-icon">
                        <i class="bi bi-gear"></i>
                    </div>
                    <div class="step-content">
                        <h3>Phase de développement</h3>
                        <p>C'est ici que les plans et les maquettes se transforment en code fonctionnel. Basée sur la planification rigoureuse effectuée en amont, cette étape voit nos équipes d'ingénieurs donner vie à votre projet, en respectant les principes d'agilité, de sécurité et de qualité.</p>
                    </div>
                    </div>
                </div>
                </div><!-- End Process Item -->

                <div class="process-item" data-aos="fade-up" data-aos-delay="400">
                <div class="content">
                    <span class="step-number">03</span>
                    <div class="card-body">
                    <div class="step-icon">
                        <i class="bi bi-search"></i>
                    </div>
                    <div class="step-content">
                        <h3>Tests &amp; Assurance qualité</h3>
                        <p>Loin d'être une simple vérification finale, c'est un processus continu et rigoureux qui vise à s'assurer que le logiciel fonctionne comme prévu, qu'il est fiable, sécurisé, performant et qu'il répond aux besoins de l'utilisateur final.</p>
                    </div>
                    </div>
                </div>
                </div><!-- End Process Item -->

                <div class="process-item" data-aos="fade-up" data-aos-delay="500">
                <div class="content">
                    <span class="step-number">04</span>
                    <div class="card-body">
                    <div class="step-icon">
                        <i class="bi bi-rocket-takeoff"></i>
                    </div>
                    <div class="step-content">
                        <h3>Lancement &amp; Assistance</h3>
                        <p>Ce n'est pas la fin du projet, mais le début de son utilisation active et de sa vie en production. Cette phase est cruciale pour assurer une adoption réussie, une performance optimale et un support durable pour les utilisateurs.</p>
                    </div>
                    </div>
                </div>
                </div><!-- End Process Item -->

            </div>
            </div>

        </div>

        </section><!-- /How We Work Section -->

        <!-- Services Section -->
        <section id="services" class="services section">

        <!-- Section Title -->
        <div class="container section-title" data-aos="fade-up">
            <h2>Services</h2>
            <p>Nous offrons les mêmes services à tous nos clients et adaptés à leur budget</p>
        </div><!-- End Section Title -->

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row justify-content-center g-5">

            <div class="col-md-6" data-aos="fade-right" data-aos-delay="100">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-code-slash"></i>
                </div>
                <div class="service-content">
                    <h3>Développement Web personnalisé</h3>
                    <p>Contrairement aux solutions "prêtes à l'emploi" ou aux plateformes génériques, une approche personnalisée garantit une adéquation parfaite avec vos processus métier, votre identité de marque et vos ambitions stratégiques.</p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-md-6" data-aos="fade-left" data-aos-delay="100">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-phone-fill"></i>
                </div>
                <div class="service-content">
                    <h3>Solutions d'Applications mobiles</h3>
                    <p>Les applications mobiles sont devenues un élément incontournable de la stratégie numérique de toute entreprise moderne. Elles offrent une connexion directe et personnalisée avec vos utilisateurs, où qu'ils soient et à tout moment. </p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-md-6" data-aos="fade-right" data-aos-delay="200">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-palette2"></i>
                </div>
                <div class="service-content">
                    <h3>Conception UI/UX</h3>
                    <p>Chez Dewiya-Tech, nous plaçons l'utilisateur au centre de notre processus de conception pour garantir que votre solution ne soit pas seulement fonctionnelle, mais qu'elle soit adoptée et aimée par ceux qui l'utilisent.</p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-md-6" data-aos="fade-left" data-aos-delay="200">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-bar-chart-line"></i>
                </div>
                <div class="service-content">
                    <h3>Visualisation des données</h3>
                    <p>Plutôt que de vous noyer dans des tableaux complexes ou des chiffres bruts, elle permet de transformer des ensembles de données volumineux et complexes en graphiques, diagrammes, cartes et tableaux de bord intuitifs et faciles à comprendre. C'est un outil indispensable pour l'analyse, la prise de décision et la communication.</p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-md-6" data-aos="fade-right" data-aos-delay="300">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-cloud-check"></i>
                </div>
                <div class="service-content">
                    <h3>Informatique en nuage</h3>
                    <p>L'informatique en nuage, ou Cloud Computing, révolutionne la façon dont les entreprises et les individus accèdent aux ressources informatiques et les utilisent. Au lieu de posséder et de gérer physiquement des serveurs, du stockage et des logiciels sur place, l'informatique en nuage permet d'accéder à ces ressources via Internet, "le nuage".</p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            <div class="col-md-6" data-aos="fade-left" data-aos-delay="300">
                <div class="service-item">
                <div class="service-icon">
                    <i class="bi bi-shield-lock"></i>
                </div>
                <div class="service-content">
                    <h3>Solutions de Cybersécurité</h3>
                    <p>Dans le paysage numérique actuel, les solutions de cybersécurité ne sont plus une option, mais une nécessité absolue. Avec l'augmentation constante des cybermenaces (rançongiciels, phishing, attaques par déni de service, vols de données), protéger vos systèmes, vos données et votre réputation est primordial.</p>
                    <a href="#" class="service-link">
                    <span>Apprendre encore plus</span>
                    <i class="bi bi-arrow-right"></i>
                    </a>
                </div>
                </div>
            </div><!-- End Service Item -->

            </div>

        </div>

        </section><!-- /Services Section -->

        <!-- Services Alt Section -->
        <section id="services-alt" class="services-alt section">

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row">
            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                <div class="content-block">
                <h6 class="subtitle">Nos services innovants</h6>
                <h2 class="title">Nos clients excellent dans la gestion de la technologie</h2>
                <p class="description">
                    En collaborant avec Dewiya-Tech, nos clients ne se contentent pas d'acquérir des outils ; ils s'associent à une expertise qui leur permet de tirer le meilleur parti de leurs investissements technologiques. Leur succès est la preuve de notre engagement à fournir des solutions qui propulsent l'excellence numérique.
                </p>
                <p class="description">
                    Vous êtes un leader dans votre domaine et cherchez un partenaire qui comprend vos ambitions technologiques ?
                </p>
                <div class="button-wrapper">
                    <a class="btn" href="#"><span>Explorez tous les services</span></a>
                </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="services-list">
                <div class="service-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="200">
                    <div class="service-icon">
                    <i class="bi bi-code-square"></i>
                    </div>
                    <div class="service-content">
                    <h4><a href="#">Génie Logiciel</a></h4>
                    <p>Loin d'être une simple activité de codage. Il s'agit de transformer des idées complexes en applications fonctionnelles, fiables, efficaces, sécurisées et maintenables, en utilisant des principes d'ingénierie éprouvés.</p>
                    </div>
                </div><!-- End Service Item -->

                <div class="service-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="300">
                    <div class="service-icon">
                    <i class="bi bi-graph-up"></i>
                    </div>
                    <div class="service-content">
                    <h4><a href="#">Analyse des données</a></h4>
                    <p>À l'ère du numérique, où les entreprises génèrent et collectent des volumes massifs d'informations, l'analyse des données est devenue une compétence et un service essentiel pour comprendre le passé, interpréter le présent et anticiper l'avenir.</p>
                    </div>
                </div><!-- End Service Item -->

                <div class="service-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="400">
                    <div class="service-icon">
                    <i class="bi bi-phone"></i>
                    </div>
                    <div class="service-content">
                    <h4><a href="#">Solutions Mobiles</a></h4>
                    <p>Chez Dewiya-Tech, nous vous aidons à concevoir et à déployer des expériences mobiles fluides et sécurisées, parfaitement adaptées à vos objectifs et aux attentes de votre public.</p>
                    </div>
                </div><!-- End Service Item -->

                <div class="service-item d-flex align-items-center" data-aos="fade-up" data-aos-delay="500">
                    <div class="service-icon">
                    <i class="bi bi-gear"></i>
                    </div>
                    <div class="service-content">
                    <h4><a href="#">Infrastructure Technologique</a></h4>
                    <p>Il s'agit de l'ensemble des composants matériels, logiciels, réseaux et installations qui supportent l'ensemble de vos opérations informatiques.</p>
                    </div>
                </div><!-- End Service Item -->
                </div>
            </div>
            </div>

        </div>

        </section><!-- /Services Alt Section -->

        <!-- Call To Action 2 Section -->
        <section id="call-to-action-2" class="call-to-action-2 section light-background">

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row g-5 align-items-center">
            <div class="col-lg-6" data-aos="fade-right" data-aos-delay="200">
                <div class="cta-image-wrapper">
                <img src="frontend/assets/img/cta/cta-4.webp" alt="Call to Action" class="img-fluid rounded-4">
                <div class="cta-pattern"></div>
                </div>
            </div>

            <div class="col-lg-6" data-aos="fade-left" data-aos-delay="300">
                <div class="cta-content">
                <h2>Transformez votre vision en réalité dès aujourd'hui</h2>
                <p class="lead">Pourquoi nous choisir ? Dewiya Technology vous donne 5 raisons.</p>

                <div class="cta-features">
                    <div class="feature-item" data-aos="zoom-in" data-aos-delay="400">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Réponse rapide</span>
                    </div>
                    <div class="feature-item" data-aos="zoom-in" data-aos-delay="450">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Sens des affaires</span>
                    </div>
                    <div class="feature-item" data-aos="zoom-in" data-aos-delay="500">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Expérimenté</span>
                    </div>
                    <div class="feature-item" data-aos="zoom-in" data-aos-delay="500">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Guichet unique</span>
                    </div>
                    <div class="feature-item" data-aos="zoom-in" data-aos-delay="500">
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Garantie de satisfaction à 100 %</span>
                    </div>
                </div>

                <div class="cta-action mt-5">
                    <a href="#" class="btn btn-primary btn-lg me-3">Commencez</a>
                    <a href="#" class="btn btn-outline-primary btn-lg">Apprendre encore plus</a>
                </div>
                </div>
            </div>
            </div>

        </div>

        </section><!-- /Call To Action 2 Section -->

        <!-- Portfolio Section -->
        <section id="portfolio" class="portfolio section">

        <!-- Section Title -->
        <div class="container section-title" data-aos="fade-up">
            <h2>Portfolio</h2>
            <p>Voici quelques-uns de nos projets terminés et en cours</p>
        </div><!-- End Section Title -->

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="isotope-layout" data-default-filter="*" data-layout="masonry" data-sort="original-order">

            <div class="portfolio-filters-container" data-aos="fade-up" data-aos-delay="200">
                <ul class="portfolio-filters isotope-filters">
                <li data-filter="*" class="filter-active">Nos réalisations</li>
                <!-- <li data-filter=".filter-web">Web Design</li>
                <li data-filter=".filter-graphics">Graphics</li>
                <li data-filter=".filter-motion">Motion</li>
                <li data-filter=".filter-brand">Branding</li> -->
                </ul>
            </div>

            <div class="row g-4 isotope-container" data-aos="fade-up" data-aos-delay="300">

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-web">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-1.png" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-1.png" class="glightbox preview-link" data-gallery="portfolio-gallery-web"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">Application Web</span>
                    <h3>Interface d'Application Moderne</h3>
                    <p>Achetez des crypto-monnaies facilement avec McBuleli.</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-graphics">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-2.png" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-2.png" class="glightbox preview-link" data-gallery="portfolio-gallery-graphics"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">Site Web</span>
                    <h3>Site Moderne</h3>
                    <p>L'Organisation Non Gouvernementale OBSERVATOIRE GOUVERNANCE ET PAIX.</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-motion">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-7.png" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-7.png" class="glightbox preview-link" data-gallery="portfolio-gallery-motion"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">Plate-forme</span>
                    <h3>Plateforme de paiement</h3>
                    <p>Profitez d'une commodité inégalée avec différents canaux de paiement.</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-brand">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-4.png" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-4.png" class="glightbox preview-link" data-gallery="portfolio-gallery-brand"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">Application Web</span>
                    <h3>Interface d'Application Moderne</h3>
                    <p>Intégrez différents modes de paiement dans vos applications Web, mobiles et Desk.</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-web">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-10.png" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-10.png" class="glightbox preview-link" data-gallery="portfolio-gallery-web"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">Application Web</span>
                    <h3>Plate-forme</h3>
                    <p>Une plateforme de gestion des caisses d'épargnes et des crédits pour les A.V.E.C, SILC</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

                <div class="col-lg-6 col-md-6 portfolio-item isotope-item filter-graphics">
                <div class="portfolio-card">
                    <div class="portfolio-image">
                    <img src="frontend/assets/img/portfolio/portfolio-11.webp" class="img-fluid" alt="" loading="lazy">
                    <div class="portfolio-overlay">
                        <div class="portfolio-actions">
                        <a href="frontend/assets/img/portfolio/portfolio-11.webp" class="glightbox preview-link" data-gallery="portfolio-gallery-graphics"><i class="bi bi-eye"></i></a>
                        <a href="portfolio-details.html" class="details-link"><i class="bi bi-arrow-right"></i></a>
                        </div>
                    </div>
                    </div>
                    <div class="portfolio-content">
                    <span class="category">SITE WEB</span>
                    <h3>Site Moderne</h3>
                    <p>L’ICCM est un réseau mondial d’Organisations de services aux enfants qui travaille en ...</p>
                    </div>
                </div>
                </div><!-- End Portfolio Item -->

            </div><!-- End Portfolio Container -->

            </div>

        </div>

        </section><!-- /Portfolio Section -->

        <!-- Pricing Section -->
        <!-- <section id="pricing" class="pricing section light-background">

        <-- Section Title 
        <-- <div class="container section-title" data-aos="fade-up">
            <h2>Pricing</h2>
            <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
        </div> <-- End Section Title 

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row g-4 justify-content-center">

            <-- Basic Plan 
            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                <div class="pricing-card">
                <h3>Basic Plan</h3>
                <div class="price">
                    <span class="currency">$</span>
                    <span class="amount">9.9</span>
                    <span class="period">/ month</span>
                </div>
                <p class="description">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium totam.</p>

                <h4>Featured Included:</h4>
                <ul class="features-list">
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Duis aute irure dolor
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Excepteur sint occaecat
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Nemo enim ipsam voluptatem
                    </li>
                </ul>

                <a href="#" class="btn btn-primary">
                    Buy Now
                    <i class="bi bi-arrow-right"></i>
                </a>
                </div>
            </div>

            <-- Standard Plan 
            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div class="pricing-card popular">
                <div class="popular-badge">Most Popular</div>
                <h3>Standard Plan</h3>
                <div class="price">
                    <span class="currency">$</span>
                    <span class="amount">19.9</span>
                    <span class="period">/ month</span>
                </div>
                <p class="description">At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum.</p>

                <h4>Featured Included:</h4>
                <ul class="features-list">
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Lorem ipsum dolor sit amet
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Consectetur adipiscing elit
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Sed do eiusmod tempor
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Ut labore et dolore magna
                    </li>
                </ul>

                <a href="#" class="btn btn-light">
                    Buy Now
                    <i class="bi bi-arrow-right"></i>
                </a>
                </div>
            </div>

            <-- Premium Plan 
            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                <div class="pricing-card">
                <h3>Premium Plan</h3>
                <div class="price">
                    <span class="currency">$</span>
                    <span class="amount">39.9</span>
                    <span class="period">/ month</span>
                </div>
                <p class="description">Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae.</p>

                <h4>Featured Included:</h4>
                <ul class="features-list">
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Temporibus autem quibusdam
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Saepe eveniet ut et voluptates
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Nam libero tempore soluta
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Cumque nihil impedit quo
                    </li>
                    <li>
                    <i class="bi bi-check-circle-fill"></i>
                    Maxime placeat facere possimus
                    </li>
                </ul>

                <a href="#" class="btn btn-primary">
                    Buy Now
                    <i class="bi bi-arrow-right"></i>
                </a>
                </div>
            </div>

            </div>

        </div>

        </section> -->
        <!-- /Pricing Section -->

        <!-- Faq Section -->
        <section id="faq" class="faq section">

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row gy-5">
            <div class="col-lg-6" data-aos="zoom-out" data-aos-delay="200">
                <div class="faq-contact-card">
                <div class="card-icon">
                    <i class="bi bi-question-circle"></i>
                </div>
                <div class="card-content">
                    <h3>Vous avez encore des questions ?</h3>
                    <p>Une équipe dédiée favorise une relation de confiance et de partenariat à long terme avec nos clients, qui se sent écouté et soutenu.</p>
                    <div class="contact-options">
                    <a href="#" class="contact-option">
                        <i class="bi bi-envelope"></i>
                        <span>Assistance par e-mail</span>
                    </a>
                    <a href="#" class="contact-option">
                        <i class="bi bi-chat-dots"></i>
                        <span>Chat en direct</span>
                    </a>
                    <a href="#" class="contact-option">
                        <i class="bi bi-telephone"></i>
                        <span>Appelez-nous</span>
                    </a>
                    </div>
                </div>
                </div>
            </div>

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="300">
                <div class="faq-accordion">
                <div class="faq-item faq-active">
                    <div class="faq-header">
                    <h3>Comment assurez-vous la sécurité de mes données et de mon application ?</h3>
                    <i class="bi bi-chevron-down faq-toggle"></i>
                    </div>
                    <div class="faq-content">
                    <p>
                        La sécurité est au cœur de notre démarche. Nous intégrons les meilleures pratiques de cybersécurité dès la conception de chaque solution (Security by Design), en utilisant des protocoles de chiffrement avancés, des tests de vulnérabilité réguliers et des systèmes de détection d'intrusion. De plus, nous respectons les normes de conformité les plus strictes pour garantir la protection de vos informations à chaque étape.
                    </p>
                    </div>
                </div><!-- End FAQ Item-->

                <div class="faq-item" data-aos="zoom-in" data-aos-delay="200">
                    <div class="faq-header">
                    <h3>Comment gérez-vous les délais et assurez-vous la livraison à temps de mes projets ?</h3>
                    <i class="bi bi-chevron-down faq-toggle"></i>
                    </div>
                    <div class="faq-content">
                    <p>
                        Nous utilisons des méthodologies agiles (comme Scrum) qui nous permettent de diviser les projets en cycles courts et itératifs appelés 'sprints'. Cela assure une planification rigoureuse, des livraisons fréquentes et transparentes, et une adaptation rapide à vos retours. Vous avez une visibilité constante sur l'avancement et nous ajustons le cap si nécessaire pour respecter les échéances.
                    </p>
                    </div>
                </div><!-- End FAQ Item-->

                <div class="faq-item">
                    <div class="faq-header">
                    <h3>Mon entreprise va évoluer. Votre solution pourra-t-elle s'adapter à mes besoins futurs ?</h3>
                    <i class="bi bi-chevron-down faq-toggle"></i>
                    </div>
                    <div class="faq-content">
                    <p>
                        Absolument. Nos solutions sont conçues avec une architecture modulaire et évolutive, utilisant des technologies modernes et flexibles. Que ce soit via l'informatique en nuage pour une évolutivité instantanée ou un développement web personnalisé qui permet des ajouts de fonctionnalités aisés, nous nous assurons que votre investissement technologique puisse grandir et s'adapter aux besoins changeants de votre entreprise sur le long terme.
                    </p>
                    </div>
                </div><!-- End FAQ Item-->

                <div class="faq-item">
                    <div class="faq-header">
                    <h3>Quel support proposez-vous une fois le logiciel déployé ?</h3>
                    <i class="bi bi-chevron-down faq-toggle"></i>
                    </div>
                    <div class="faq-content">
                    <p>
                        Notre engagement ne s'arrête pas au lancement. Nous offrons une assistance dédiée après le déploiement, incluant la maintenance corrective (pour les bugs), préventive (pour optimiser les performances) et évolutive (pour les nouvelles fonctionnalités). Notre équipe est là pour vous garantir un fonctionnement optimal et vous accompagner dans l'utilisation et l'évolution de votre solution.
                    </p>
                    </div>
                </div><!-- End FAQ Item-->
                </div>
            </div>
            </div>

        </div>

        </section><!-- /Faq Section -->

        <!-- Team Section -->
         <!--
        <section id="team" class="team section light-background">

        <-- Section Title --
        <div class="container section-title" data-aos="fade-up">
            <h2>Notre équipe</h2>
            <p>En choisissant Dewiya-Tech, vous ne louez pas seulement des compétences ; vous intégrez une équipe dédiée, passionnée et expérimentée, prête à s'investir pleinement dans la réussite de vos projets technologiques.
               Nous sommes impatients de mettre notre expertise au service de votre prochaine innovation.</p>
        </div><-- End Section Title --

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row g-5">

            <div class="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="100">
                <div class="team-card">
                <div class="team-image">
                    <img src="frontend/assets/img/person/person-m-1.webp" class="img-fluid" alt="">
                    <div class="team-overlay">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla quam velit, vulputate eu pharetra nec, mattis ac neque.</p>
                    <div class="team-social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                    </div>
                </div>
                <div class="team-content">
                    <h4>Daniel Mitchell</h4>
                    <span class="position">Creative Director</span>
                </div>
                </div>
            </div><-- End Team Member --

            <div class="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="200">
                <div class="team-card">
                <div class="team-image">
                    <img src="frontend/assets/img/person/person-f-6.webp" class="img-fluid" alt="">
                    <div class="team-overlay">
                    <p>Aliquam tincidunt mauris eu risus. Vestibulum auctor dapibus neque. Nunc dignissim risus id metus.</p>
                    <div class="team-social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                    </div>
                </div>
                <div class="team-content">
                    <h4>Rebecca Taylor</h4>
                    <span class="position">Lead Developer</span>
                </div>
                </div>
            </div><-- End Team Member --

            <div class="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="300">
                <div class="team-card">
                <div class="team-image">
                    <img src="frontend/assets/img/person/person-m-6.webp" class="img-fluid" alt="">
                    <div class="team-overlay">
                    <p>Cras ornare tristique elit. Integer in dui quis est placerat ornare. Phasellus a lacus a risus.</p>
                    <div class="team-social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                    </div>
                </div>
                <div class="team-content">
                    <h4>Marcus Johnson</h4>
                    <span class="position">UI/UX Designer</span>
                </div>
                </div>
            </div> 
            <-- End Team Member --

            <div class="col-md-6 col-lg-3" data-aos="zoom-in" data-aos-delay="400">
                <div class="team-card">
                <div class="team-image">
                    <img src="frontend/assets/img/person/person-f-3.webp" class="img-fluid" alt="">
                    <div class="team-overlay">
                    <p>Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas.</p>
                    <div class="team-social">
                        <a href=""><i class="bi bi-twitter-x"></i></a>
                        <a href=""><i class="bi bi-facebook"></i></a>
                        <a href=""><i class="bi bi-instagram"></i></a>
                        <a href=""><i class="bi bi-linkedin"></i></a>
                    </div>
                    </div>
                </div>
                <div class="team-content">
                    <h4>Jessica Parker</h4>
                    <span class="position">Marketing Strategist</span>
                </div>
                </div>
            </div> 
            <-- End Team Member --

            </div>

        </div>

        </section> -->
        <!-- /Team Section -->

        <!-- Testimonials Section -->
        <section id="testimonials" class="testimonials section">

        <!-- Section Title -->
        <div class="container section-title" data-aos="fade-up">
            <h2>Témoignages</h2>
            <p>Nous partageons avec vous quelques témoignages de nos clients</p>
        </div><!-- End Section Title -->

        <div class="container" data-aos="fade-up" data-aos-delay="100">
            <div class="testimonials-slider swiper">
            <!-- <div class="testimonials-slider swiper init-swiper"> -->
            <!-- <script type="application/json" class="swiper-config">
                {
                "loop": true,
                "speed": 800,
                "autoplay": {
                    "delay": 5000
                },
                "slidesPerView": 1,
                "spaceBetween": 30,
                "pagination": {
                    "el": ".swiper-pagination",
                    "type": "bullets",
                    "clickable": true
                },
                "breakpoints": {
                    "768": {
                    "slidesPerView": 2
                    },
                    "1200": {
                    "slidesPerView": 3
                    }
                }
                }
            </script> -->
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Dewiya-Tech a révolutionné notre façon de travailler. Leur approche du développement web personnalisé a abouti à une plateforme qui non seulement répondait à tous nos besoins, mais les a même dépassés en termes de performance et d'expérience utilisateur. Leur équipe de conception UI/UX a vraiment compris notre vision, et le résultat est à la fois intuitif et esthétique. L'assistance dédiée après le lancement a été impeccable, ce qui est rare de nos jours.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-m-8.jpg" alt="Profile Image">
                        <div>
                        <h3>Jeff BULELI</h3>
                        <h4>CEO McBuleli Inc.</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->

                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Dewiya-Tech a révolutionné notre façon de travailler. Leur approche du développement web personnalisé a abouti à une plateforme qui non seulement répondait à tous nos besoins, mais les a même dépassés en termes de performance et d'expérience utilisateur. Leur équipe de conception UI/UX a vraiment compris notre vision, et le résultat est à la fois intuitif et esthétique. L'assistance dédiée après le lancement a été impeccable, ce qui est rare de nos jours.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-f-3.webp" alt="Profile Image">
                        <div>
                        <h3>Lisa Williams</h3>
                        <h4>Product Manager</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->

                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Enim nisi quem export duis labore cillum quae magna enim sint quorum nulla quem veniam duis minim tempor labore quem eram duis noster aute amet eram.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-f-10.webp" alt="Profile Image">
                        <div>
                        <h3>Emma Parker</h3>
                        <h4>UX Designer</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->

                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Fugiat enim eram quae cillum dolore dolor amet nulla culpa multos export minim fugiat minim velit minim dolor enim duis veniam ipsum anim magna sunt elit.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-m-5.webp" alt="Profile Image">
                        <div>
                        <h3>David Miller</h3>
                        <h4>Senior Developer</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->

                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Quis quorum aliqua sint quem legam fore sunt eram irure aliqua veniam tempor noster veniam enim culpa labore duis sunt culpa nulla illum cillum fugiat.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-m-2.webp" alt="Profile Image">
                        <div>
                        <h3>Michael Davis</h3>
                        <h4>CEO &amp; Founder</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->

                <div class="swiper-slide">
                <div class="testimonial-card">
                    <div class="testimonial-content">
                    <p>
                        <i class="bi bi-quote quote-icon"></i>
                        Eius ipsam praesentium dolor quaerat inventore rerum odio. Quos laudantium adipisci eius. Accusamus qui iste cupiditate sed temporibus est aspernatur.
                    </p>
                    </div>
                    <div class="testimonial-profile">
                    <div class="rating">
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                        <i class="bi bi-star-fill"></i>
                    </div>
                    <div class="profile-info">
                        <img src="frontend/assets/img/person/person-f-7.webp" alt="Profile Image">
                        <div>
                        <h3>Sarah Thompson</h3>
                        <h4>Art Director</h4>
                        </div>
                    </div>
                    </div>
                </div>
                </div><!-- End testimonial item -->
            </div>
            <div class="swiper-pagination"></div>
            </div>

        </div>

        </section><!-- /Testimonials Section -->

        <!-- Contact Section -->
        <section id="contact" class="contact section">

        <!-- Section Title -->
        <div class="container section-title" data-aos="fade-up">
            <h2>Nous contacter</h2>
            <p>Prêt à transformer vos idées en solutions numériques concrètes ? Notre équipe est impatiente de collaborer avec vous et de mettre notre expertise au service de vos ambitions.
               Que vous ayez une question, un projet à discuter ou que vous souhaitiez simplement en savoir plus sur nos services, n'hésitez pas à nous contacter. Nous sommes là pour vous accompagner.</p>
        </div><!-- End Section Title -->

        <div class="container" data-aos="fade-up" data-aos-delay="100">

            <div class="row gy-4 mb-5">
            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="100">
                <div class="info-card">
                <div class="icon-box">
                    <i class="bi bi-geo-alt"></i>
                </div>
                <h3>Notre adresse</h3>
                <p>01 Av MAHENGE Athénée, Q. Ndendere, C. Ibanda. RDC</p>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="200">
                <div class="info-card">
                <div class="icon-box">
                    <i class="bi bi-telephone"></i>
                </div>
                <h3>Numéro de contact</h3>
                <p>WhatsApp : +243 82 39 39 081<br>
                    Email : info@dewiyatech.com</p>
                </div>
            </div>

            <div class="col-lg-4" data-aos="fade-up" data-aos-delay="300">
                <div class="info-card">
                <div class="icon-box">
                    <i class="bi bi-clock"></i>
                </div>
                <h3>Heure d'ouverture</h3>
                <p>Du Lundi au Vendredi : 8:00 - 17:00<br>
                    Weekend : Fermé</p>
                </div>
            </div>
            </div>

            <div class="row">
            <div class="col-lg-12">
                <div class="form-wrapper" data-aos="fade-up" data-aos-delay="400">
                <form action="forms/contact.php" method="post" role="form" class="php-email-form">
                    <div class="row">
                    <div class="col-md-6 form-group">
                        <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-person"></i></span>
                        <input type="text" name="name" class="form-control" placeholder="Votre nom*" required="">
                        </div>
                    </div>
                    <div class="col-md-6 form-group">
                        <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-envelope"></i></span>
                        <input type="email" class="form-control" name="email" placeholder="Adresse email*" required="">
                        </div>
                    </div>
                    </div>
                    <div class="row mt-3">
                    <div class="col-md-6 form-group">
                        <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-phone"></i></span>
                        <input type="text" class="form-control" name="phone" placeholder="Numéro de téléphone*" required="">
                        </div>
                    </div>
                    <div class="col-md-6 form-group">
                        <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-list"></i></span>
                        <select name="subject" class="form-control" required="">
                            <option value="">Sélectionnez un service*</option>
                            <option value="Service 1">Développement Web personnalisé</option>
                            <option value="Service 2">Solutions d'Applications mobiles</option>
                            <option value="Service 3">Conception UI/UX</option>
                            <option value="Service 4">Visualisation des données</option>
                            <option value="Service 5">Informatique en nuage</option>
                            <option value="Service 6">Solutions de Cybersécurité</option>
                        </select>
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <div class="input-group">
                        <span class="input-group-text"><i class="bi bi-chat-dots"></i></span>
                        <textarea class="form-control" name="message" rows="6" placeholder="Écrire un message*" required=""></textarea>
                        </div>
                    </div>
                    <div class="my-3">
                        <div class="loading">Chargement</div>
                        <div class="error-message"></div>
                        <div class="sent-message">Votre message a été envoyé. Merci !</div>
                    </div>
                    <div class="text-center">
                        <button type="submit">Envoyer un message</button>
                    </div>

                    </div>
                </form>
                </div>
            </div>

            </div>

        </div>
        </section><!-- /Contact Section -->

    </main>
      <footer id="footer" class="footer light-background">

    <div class="container footer-top">
      <div class="row gy-4">
        <div class="col-lg-4 col-md-6 footer-about">
          <a href="index.html" class="logo d-flex align-items-center">
            <span class="sitename">Dewiya-Tech</span>
          </a>
          <div class="footer-contact pt-3">
            <p>01 Av MAHENGE Athénée, </p>
            <p>Q. Ndendere, C. Ibanda. RDC</p>
            <p class="mt-3"><strong>Téléphone:</strong> <span>+243 82 39 39 081</span></p>
            <p><strong>E-mail:</strong> <span>info@dewiyatech.com</span></p>
          </div>
          <div class="social-links d-flex mt-4">
            <a href=""><i class="bi bi-twitter-x"></i></a>
            <a href=""><i class="bi bi-facebook"></i></a>
            <a href=""><i class="bi bi-instagram"></i></a>
            <a href=""><i class="bi bi-linkedin"></i></a>
          </div>
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <h4>Liens utiles</h4>
          <ul>
            <li><a href="#">Accueil</a></li>
            <li><a href="#">À propos</a></li>
            <li><a href="#">Services</a></li>
            <li><a href="#">Conditions d'utilisation</a></li>
            <li><a href="#">Politique de confidentialité</a></li>
          </ul>
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <h4>Nos prestations</h4>
          <ul>
            <li><a href="#">Développement Web personnalisé</a></li>
            <li><a href="#">Solutions d'Applications mobiles</a></li>
            <li><a href="#">Conception UI/UX</a></li>
            <li><a href="#">Solutions de Cybersécurité</a></li>
            <!-- <li><a href="#">Graphic Design</a></li> -->
          </ul>
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <h4>Support</h4>
          <ul>
            <li><a href="#">Nous contacter</a></li>
            <li><a href="#">Soumettre un ticket</a></li>
            <li><a href="#">Services professionnels</a></li>
            <li><a href="#">Système de support</a></li>
            <li><a href="#">Politique de remboursement</a></li>
          </ul>
        </div>

        <div class="col-lg-2 col-md-3 footer-links">
          <h4>Quoi de neuf</h4>
          <ul>
            <li><a href="https://liza.dewiyatech.com" target="_blank">Liza</a></li>
            <li><a href="#">Shappu</a></li>
            <li><a href="#">Huremas</a></li>
            <li><a href="#">WekaPesa</a></li>
            <li><a href="#">Kurahisisha</a></li>
          </ul>
        </div>

      </div>
    </div>

    <div class="container copyright text-center mt-4">
      <p>Copyright © <span>2026</span> <strong class="px-1 sitename">Dewiya-Tech</strong> <span>All Rights Reserved</span></p>
      <div class="credits">
        <!-- All the links in the footer should remain intact. -->
        <!-- You can delete the links only if you've purchased the pro version. -->
        <!-- Licensing information: https://bootstrapmade.com/license/ -->
        <!-- Purchase the pro version with working PHP/AJAX contact form: [buy-url] -->
        Designed by <a href="https://dewiyatech.com">Dewiya-Tech</a>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
    name: 'Master',
};
</script>



<style>

</style>